import { isEmpty } from "lodash";

function customStringify(obj: any) {
  const stringIdentifier = "¿";

  const stringified = JSON.stringify(
    obj,
    (key, value) => {
      // look for "enum" values and encapsulate the value in square brackets
      // to avoid the value being treated as a string value
      if (typeof value === "object" && (key === "in" || key === "nin")) {
        return "[" + value + "]";
      }

      // remove empty objects
      if (typeof value === "object" && isEmpty(value) && value !== null) {
        return "";
      }

      // find string values and add temporary identifiers
      if (typeof value === "string") {
        return stringIdentifier + value + stringIdentifier;
      }
      return value;
    },
    " ",
  );

  // remove quotation marks from keys and values
  const r1 = stringified.replaceAll('\\"', "").replaceAll('"', "");

  // remove string identifiers and add quotation marks "back" to string values
  const r2 = r1.replaceAll(stringIdentifier, '"');

  // return the formatted string
  return r2;
}

export const f = <T>() => {
  const filters: Array<string> = [];

  const builder = {
    // functions
    addFilter<K extends keyof T>(key: K, value: T[K]) {
      filters.push(`{ ${String(key)}: ${customStringify(value)} }`);
      return builder;
    },

    addFilterIf<K extends keyof T>(conditional: boolean, key: K, value: T[K]) {
      if (conditional) {
        filters.push(`{ ${String(key)}: ${customStringify(value)} }`);
      }
      return builder;
    },

    // build the filters to string
    build() {
      return filters.map((f) => f).join("\n");
    },
  };
  return builder;
};
